import React, { useMemo, useState } from 'react';
import { ReactComponent as PurpleTimes } from '../../../assets/icons/PurpleTimes.svg';
import Loading from '../../../common/Loading';
import { fabric } from 'fabric';
type Type = {
	obj: any;
	canvas?: fabric.Canvas;
	loading?: boolean;
};

function ShowImagePreview({ obj, canvas, loading = false }: Type) {
	const imageUrl = useMemo(() => (loading ? null : (obj as any).getElement()?.src), [obj, loading]);

	const deleteObj = () => {
		const rootObj = { ...obj.rootObj };
		rootObj.set({ fill: 'transparent' });

		// Store the original index of the object before removing it
		const objects = canvas?.getObjects() || [];
		const objIndex = obj ? objects.indexOf(obj) : -1;
		const frameObject = objects.find((o: any) => obj?.frameId === o.id);
		const frameIndex = frameObject ? objects.indexOf(frameObject) : -1;

		// Determine the insertion index (use the lower of the two indexes)
		const insertionIndex = Math.min(objIndex !== -1 ? objIndex : Infinity, frameIndex !== -1 ? frameIndex : Infinity);

		// Create the replacement object
		const createObjFunction = obj.createObjFunction;
		const newRootObj = { ...rootObj };
		const oldRootElement = obj.createObjFunction(rootObj);
		(oldRootElement as any).rootObj = newRootObj;
		(oldRootElement as any).createObjFunction = createObjFunction;

		// Remove the existing objects
		canvas?.remove(obj);
		if (frameObject) canvas?.remove(frameObject);

		// Add the new object
		canvas?.add(oldRootElement);

		// Move the new object to the correct index in the stack
		if (insertionIndex !== Infinity && canvas) {
			// Ensure we have a valid number for the moveTo method
			canvas.moveTo(oldRootElement, insertionIndex as number);
		}

		canvas?.requestRenderAll();
	};

	return (
		<div className="rounded-[10px] bg-[#F1F1FEB3] w-[92px] h-[92px] flex items-center justify-center relative overflow-hidden">
			{loading ? (
				<Loading height={30} />
			) : (
				<>
					<button className="top-[5px] right-[5px] w-[14px] h-[15px] rounded-full bg-[#F1F1FE] flex items-center justify-center absolute" onClick={deleteObj}>
						<PurpleTimes />
					</button>
					<img src={imageUrl} width={90} height={90} alt="" />
				</>
			)}
		</div>
	);
}

export default ShowImagePreview;
